// hooks/useCarWashActions.ts
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../../../features/auth/axiosConfig";
import { MultiCarItem } from "../../home/components/types";
import { Product } from "src/shared/services/interfacev2";

interface UseCarWashActionsProps {
  multiCar: MultiCarItem[];
  editCarIndex: number | null;
  customerId: string | null;
  calculateTotalPrice: () => number | string;
  addProductToCar: (product: Product, carIndex: number | null) => void;
  setIsModalOpen: (val: boolean) => void;
  clearAllData?: () => void;
}

export const useCarWashActions = ({ multiCar, editCarIndex, customerId, calculateTotalPrice, addProductToCar, setIsModalOpen, clearAllData }: UseCarWashActionsProps) => {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState<"cash" | "Buy on credit">(() => {
    const saved = localStorage.getItem("carWashPaymentMethod");
    return (saved as "cash" | "Buy on credit") || "cash";
  });

  /** Add product to selected car */
  const handleProductClick = useCallback(
    (product: Product) => {
      if (multiCar.length === 0) {
        toast.warning("Please add a car first.");
        setIsModalOpen(true);
        return;
      }
      addProductToCar(product, editCarIndex);
    },
    [multiCar, editCarIndex, addProductToCar, setIsModalOpen]
  );

  const handlePaymentMethodChange = useCallback((method: "cash" | "Buy on credit") => {
    setPaymentMethod(method);
  }, []);

  const handleNext = useCallback(async () => {
  if (!multiCar.length || multiCar.every((car) => car.productDetails.length === 0)) {
    toast.warning("Please select at least one product before proceeding.");
    return;
  }

  const updateData = {
    totalOrderPrice: calculateTotalPrice(),
    serviceDetails: multiCar,
    payment: {
      paymentMethod,
    },
    productIds: multiCar.flatMap((car) => car.productDetails.map((product) => product._id.$oid)),
  };

  try {
    await api.put(`/app/pos/v2/shopping_cart/${customerId}`, updateData);
    await api.post(`/app/pos/v2/shopping_cart/${customerId}`, updateData);
    navigate(`/v1/car-payment-cash?id=${customerId}`);
  } catch (error) {
    console.error("Error updating car details:", error);
    toast.error("Failed to process order. Please try again.");
  }
}, [multiCar, calculateTotalPrice, customerId, paymentMethod, navigate]);


  return {
    handleProductClick,
    handleNext,
    paymentMethod,
    handlePaymentMethodChange,
  };
};